import { SortDirection, TableSort } from "../tables/table";
import { DEFAULT_PAGE_SIZE, viewTypes } from "./views";

export enum InventoryLevelsSystemView {
  ALL = "all",
}

export const sortDefault: TableSort = {
  direction: SortDirection.ASC,
  key: "title",
};

const defaultColumns = [
  { key: "title", width: 350, hidden: false },
  { key: "vendor", width: 150, hidden: false },
  { key: "cost", width: 100, hidden: false },
  { key: "merchant", width: 180, hidden: true },
  { key: "totalAvailable", width: 120, hidden: false },
  { key: "totalQuantity", width: 120, hidden: false },
  { key: "totalCommitted", width: 120, hidden: false },
  { key: "totalReserved", width: 120, hidden: false },
];

export const StaticSystemViews: Record<
  InventoryLevelsSystemView,
  viewTypes["inventory-levels"]
> = {
  [InventoryLevelsSystemView.ALL]: {
    table: "inventory-levels",
    name: InventoryLevelsSystemView.ALL,
    filters: [],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: sortDefault,
    position: 0,
    isNotEditable: true,
  },
};

export function friendlyViewName(view: viewTypes["inventory-levels"]) {
  switch (view.name) {
    case InventoryLevelsSystemView.ALL:
      return "All";
    default:
      return view.name;
  }
}
